import { useMap } from '@vis.gl/react-google-maps';
import { useEffect } from 'react';

import type { MapCameraToPlaceEffectProps } from '.';

/**
 * React effect that moves the map camera to the provided Place.
 *
 * Behavior:
 * - If the place has a `viewport`, the map will fit bounds to that viewport.
 * - Otherwise, if it has a `location`, the map will pan to it and set zoom to 15.
 *
 * Use this component inside a GoogleMap context. It renders nothing.
 *
 * @param mapCameraToPlaceEffectProps - Component props with the target place.
 * @returns null
 */
export function MapCameraToPlaceEffect(mapCameraToPlaceEffectProps: MapCameraToPlaceEffectProps) {
  const { place } = mapCameraToPlaceEffectProps;
  const map = useMap();
  useEffect(() => {
    if (!map || !place) return;
    if (place.viewport) {
      map.fitBounds(place.viewport);
    } else if (place.location) {
      map.panTo(place.location);
      map.setZoom(15);
    }
  }, [map, place]);
  return null;
}
